/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IButtonsampleViewProps } from './buttonsample';

export default (props: IButtonsampleViewProps) => {
    return (
        <div className='button-example'>
            <h1 className='section-title'>BUTTONS</h1>
            <h1 className='section-title'>PRIMARY BUTTONS</h1>

            <button className='button button-basics'>Primary</button>

            <button className='button button-alternate'>Alternate</button>

            <button className='button button-secondary'>Secondary</button>

            <button className='button button-counter'>Counter Action</button>

            <button className='button button-basics' disabled>
                Disabled
            </button>

            <hr></hr>
            <h1 className='section-title'>BUTTON SIZES</h1>
            <button className='button button-basics small'>Small ~32px</button>

            <button className='button button-basics medium'>Medium (Default) ~48px</button>

            <button className='button button-basics large'>Large ~64px</button>

            <hr></hr>
        </div>
    );
};
